// eslint-disable-next-line
export default {
	color: {
		primary: '#0F9BB0',
		secondary: '#23AFC4',
		light: '#A6DCE5',
		white: '#FFFFFF'
	},
	font: {
		fontFamilyPoppins: 'Poppins',
	},
};
